import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
  OnDestroy
} from '@angular/core';
import { CMSContentService } from '../essentials/cms/content/cms-content.service';
import { AzureSearchService } from '../../app/essentials/azure/search/search.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SlugPipe } from '../essentials/modules/pipe/slug/slug.pipe';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import { PublishingHighlightService } from './publishing-highlight.service';
import {
  PublishingConfigsData,
  PublishingHighlightData,
  PublishingAbout,
  PublishingHighlightButtonData,
  PublishingItemMenu
} from '../shared/models/publishing-highlight.model';

@Component({
  selector: 'fcp-publishing-highlight',
  templateUrl: './publishing-highlight.component.html',
  styleUrls: ['./publishing-highlight.component.scss']
})
export class PublishingHighlightComponent implements OnInit, OnDestroy {
  @ViewChild('bannerMenu', { static: true }) bannerMenu: ElementRef;

  public button: Array<PublishingHighlightButtonData>;
  public publishingHighlight: PublishingHighlightData;
  public itemMenuPublishing: PublishingItemMenu;
  public itemMenuNews: PublishingItemMenu;
  public publishingAbout: PublishingAbout;
  public suggestions: Array<any>;
  public publishing: Array<any>;
  public selectedCategory: string;
  public pageLocation: string;
  public searchTerm: string;
  public isDeviceDesktop: boolean;
  public isDetailScreen: boolean;
  public showResults: boolean;
  public firstLoad: boolean;
  public loading: boolean;
  public page: number;
  public top: number;
  public anyPageButtons: any;
  public buttonSetting: any;

  private itemFloatMenuPublishing: PublishingItemMenu;
  private publishingConfigs: PublishingConfigsData;
  private itemFloatMenuNews: PublishingItemMenu;
  private resizeObservable$: Observable<Event>;
  private resizeSubscription$: Subscription;
  private allPublishing: Array<any>;
  private heightHeader: number;
  private skip: number;

  constructor(
    private cmsContent: CMSContentService,
    private publishingHighlightService: PublishingHighlightService,
    private azureService: AzureSearchService,
    private router: Router,
    private route: ActivatedRoute,
    private slugPipe: SlugPipe
  ) {
    this.initVariables();
    this.loadContent();
  }

  public ngOnInit(): void {
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$
      .pipe(debounceTime(300), take(1))
      .subscribe(() => this.checkDevice());
  }

  public ngOnDestroy(): void {
    this.resizeSubscription$.unsubscribe();
  }

  @HostListener('window:scroll', ['$event'])
  public onWindowScroll(from?: any) {
    let footerPosition = 0;
    const bannerElement = document.getElementsByClassName(
      'section-publishing-highlight__banner'
    )[0];
    if (bannerElement) {
      footerPosition = bannerElement.clientHeight;
    }
    if (window.pageYOffset > footerPosition) {
      this.bannerMenu.nativeElement.classList.add('position-fixed');
    } else {
      this.bannerMenu.nativeElement.classList.remove('position-fixed');
    }
  }

  public actionSearchTerm($event, search?: boolean) {
    const searchTerm = this.searchTerm;
    const key = $event.key ? $event.key.toLowerCase() : null;
    const hitEnterOrSearchButton = key === 'enter' || search;

    if (!searchTerm && hitEnterOrSearchButton) {
      window.location.href = 'publicacoes';
      return;
    }

    if (searchTerm && searchTerm.length > 0) {
      if (hitEnterOrSearchButton) {
        search = true;
        this.firstLoad = false;
        window.location.href = `publicacoes?q=${searchTerm}`;
      } else if (/[a-z]/.test(key)) {
        this.getSuggestions(searchTerm);
      }
    }
  }

  public openModal(modal: string): void {
    if (modal) {
      this.cmsContent.openModal(modal);
    }
  }

  public goTo(article: any): void {
    this.router.navigateByUrl(`publicacoes/${article.slug}`);
  }

  public getBackground(attr) {
    return {
      background: `url(${attr})`
    };
  }

  public changePage(page) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { p: page },
      queryParamsHandling: 'merge'
    });
  }

  private initVariables(): void {
    this.pageLocation = 'initial';
    this.showResults = false;
    this.firstLoad = false;
    this.loading = false;
    this.selectedCategory = '';
    this.heightHeader = 77;
    this.page = 1;
    this.top = 12;
    this.skip = 0;
    this.publishing = [];
    this.allPublishing = [];
    this.suggestions = [];
    this.button = [new PublishingHighlightButtonData()];
    this.itemFloatMenuNews = {
      title: `IR PARA NOTÍCIAS`,
      url: '/noticias'
    };
    this.itemFloatMenuPublishing = {
      title: `IR PARA PUBLICAÇÕES`,
      url: '/publicacoes'
    };
    this.publishingHighlight = new PublishingHighlightData();
    this.isDetailScreen = this.checkIfIsDetailScreen();
  }

  private loadContent(): void {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      if (location.pathname.indexOf('/publicacoes') >= 0) {
        if (params['p']) {
          this.page = +params['p'];
        }

        if (params['q']) {
          this.searchTerm = params['q'];
          this.getContent(params['q']);
        } else {
          this.getContent('');
        }
      }
    });
  }

  private checkIfIsDetailScreen(): boolean {
    return (
      this.isDefined(this.route.snapshot.paramMap.get('slug')) ||
      this.isDefined(this.route.snapshot.paramMap.get('title'))
    );
  }

  private isDefined(value: any): boolean {
    return value !== null && value !== undefined;
  }

  private getSuggestions(term) {
    this.showResults = false;
    if (term !== '') {
      this.azureService
        .getSuggestions(term, 'Publicações')
        .pipe(take(1))
        .subscribe(results => {
          this.suggestions = results;
        });
    }
  }

  private search(term, termAfter?: string) {
    this.suggestions = [];
    this.loading = true;

    if (this.page === 1) {
      this.skip = 0;
    } else {
      this.skip = (this.page - 1) * this.top;
    }

    this.azureService
      .getCognitiveSearch(term, 'Publicações')
      .pipe(take(1))
      .subscribe(results => {
        this.publishing = this.mapPublishing(results.value);

        if (term === '*') {
          this.allPublishing = JSON.parse(JSON.stringify(this.publishing));
          this.publishingHighlight.menu = this.buildMenuCategory(
            this.allPublishing
          );
          this.checkDevice();
          if (termAfter) {
            this.search(termAfter);
          } else {
            this.showResults = true;
            this.firstLoad = true;
            this.loading = false;
          }
        } else {
          this.showResults = true;
          this.firstLoad = true;
          this.loading = false;
        }

        if (this.isDetailScreen) {
          window.scrollTo(0, 500);
        }

        this.route.params.pipe(take(1)).subscribe(params => {
          if (params.subcategory) {
            // select sub category
            this.selectCategory(params.category, params.subcategory);
          } else if (params.category) {
            this.selectCategory(params.category);
          }
        });
      });
  }

  private getContent(termAfter?: string): void {
    this.publishingHighlightService
      .getConfigPublishing()
      .pipe(take(1))
      .subscribe((publishingConfigs: PublishingConfigsData) => {
        this.publishingConfigs = publishingConfigs || null;
        this.setConfigHighlightsPublishing(this.publishingConfigs);
        this.search('*', termAfter);
      });
  }

  private mapPublishing(data) {
    const newData = data.map(publishing => {
      return {
        id: publishing.id,
        slug: '/publicacoes/' + publishing.slug,
        subcategory: publishing.subcategory,
        name: publishing.name,
        type: publishing.type,
        category: publishing.category,
        subtitle: publishing.subtitle,
        date: publishing.date,
        image: publishing.image
      };
    });
    return newData;
  }

  private getAbout(param: string) {
    this.cmsContent
      .getPublishingAbout(param)
      .pipe(take(1))
      .subscribe(about => {
        this.publishingAbout = about;
      });
  }

  public selectCategory(category: string, subcategory?: string) {
    this.pageLocation = 'secondary';
    let titleCategory = '';
    const myPublishing = this.filterPublishing(this.allPublishing);
    this.publishingAbout = null;
    this.publishing = myPublishing.filter(article => {
      if (this.slugPipe.transform(article.category) === category) {
        if (subcategory) {
          if (
            this.slugPipe.transform(article.category) === category &&
            this.slugPipe.transform(article.subcategory) === subcategory
          ) {
            titleCategory = article.subcategory;
            return article;
          }
        } else {
          if (this.slugPipe.transform(article.category) === category) {
            titleCategory = article.category;
            if (!this.publishingAbout) {
            }
            return article;
          }
        }
      }
    });

    if (this.publishing.length > 0) {
      this.selectedCategory = titleCategory;
      this.getAbout(titleCategory);
      const hasSubcategory = this.publishing.every(publish => {
        return (
          publish.subcategory !== '' && publish.subcategory !== subcategory
        );
      });
      if (hasSubcategory) {
        this.publishingHighlight.menu = this.buildMenuSubcategory(
          this.publishing
        );
        this.checkDevice();
      }
    } else {
      this.selectedCategory = `As publicações ainda não foram cadastradas.`;
    }
  }

  private buildMenuCategory(
    list: Array<any>
  ): Array<{ title: string; url: string }> {
    return this.mapMenu(list, 'category');
  }

  private mapMenu(list, type) {
    if (type === 'category') {
      return list
        .map(item => {
          return item[type];
        })
        .filter((item, index, array) => array.indexOf(item) === index)
        .map(title => {
          const url = '/publicacoes/' + this.slugPipe.transform(title);
          return { title, url };
        });
    } else {
      const unfiltered = list
        .map(item => {
          return {
            category: item['category'],
            subcategory: item['subcategory']
          };
        })
        .filter((item, index, array) => {
          return array.indexOf(item) === index;
        })
        .map(item => {
          const url =
            '/publicacoes/' +
            this.slugPipe.transform(item.category) +
            '/' +
            this.slugPipe.transform(item.subcategory);
          return { title: item.subcategory, url };
        });
      return this.groupCategory(unfiltered);
    }
  }

  private buildMenuSubcategory(
    list: Array<any>
  ): Array<{ title: string; url: string }> {
    return this.mapMenu(list, 'subcategory');
  }

  private groupCategory(arr) {
    const group = arr.reduce((acc, item) => {
      acc[item.title] = item.url;
      return acc;
    }, {});
    return Object.keys(group).map(key => {
      return { url: group[key], title: key };
    });
  }

  private filterPublishing(news: any): any[] {
    return news.filter(
      newItem => this.publishingConfigs.banner !== newItem.image
    );
  }

  private setConfigHighlightsPublishing(config: any): void {
    this.publishingHighlight.title = config.banner?.title;
    this.publishingHighlight.subtitle = config.banner?.description;
    this.publishingHighlight.image = config.banner?.image;

    config.standardNavigationButtons.forEach(item => {
      item.pageLocation === 'initial'
        ? ((this.itemFloatMenuNews = {
            title: item.title,
            url: item.destinationPage,
            pageLocation: item.pageLocation
          }),
          (this.itemMenuNews = {
            title: item.title,
            url: item.destinationPage,
            icon: item.icon,
            pageLocation: item.pageLocation
          }))
        : ((this.itemFloatMenuPublishing = {
            title: item.title,
            url: item.destinationPage,
            pageLocation: item.pageLocation
          }),
          (this.itemMenuPublishing = {
            title: item.title,
            url: item.destinationPage,
            icon: item.icon,
            pageLocation: item.pageLocation
          }));
    });

    this.anyPageButtons = config.anyPageButtons;
    this.buttonSetting = {
      label: config.cardButtonLabel,
      style: config.styleButtonCardPublishing
    };
  }

  private checkDevice() {
    if (window.innerWidth < 769) {
      this.isDeviceDesktop = false;
      this.addReturnFromTheFloatingMenu();
      return;
    }
    this.isDeviceDesktop = true;
    this.removeReturnFromTheFloatingMenu();
  }

  private addReturnFromTheFloatingMenu() {
    if (!this.hasReturnInTheFloatingMenu()) {
      this.publishingHighlight.menu.push(
        this.pageLocation === 'initial'
          ? this.itemFloatMenuNews
          : this.itemFloatMenuPublishing
      );
    }
  }

  private hasReturnInTheFloatingMenu() {
    return this.publishingHighlight.menu.find(
      item => item.pageLocation === this.pageLocation
    );
  }

  private removeReturnFromTheFloatingMenu() {
    if (this.hasReturnInTheFloatingMenu()) {
      this.publishingHighlight.menu.pop();
    }
  }
}
